import React from 'react'

const Confidentiality = () => (
  <div>{/*<img alt="cataloge" src={`${require('../../assets/ZadigCatalogue.jpg')}`} />*/}</div>
)

export default Confidentiality
